import { defineStore } from 'pinia'
import { clearSession, loadSession, saveSession, type SessionData } from '@/core/storage/session'
import { setHttpAccessToken } from '@/core/http/client'
import type { MenuRouteDto, UserProfile } from '@/models/auth'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    tokenName: 'satoken',
    tokenValue: '',
    needModify: false,
    version: '',
    user: null as UserProfile | null,
    menus: [] as MenuRouteDto[],
    restored: false
  }),
  getters: {
    isAuthenticated: (state) => Boolean(state.tokenValue)
  },
  actions: {
    async restore() {
      const session = loadSession()
      if (session) {
        this.tokenName = session.tokenName
        this.tokenValue = session.tokenValue
        this.needModify = Boolean(session.needModify)
        this.version = session.version || ''
        setHttpAccessToken(session.tokenValue, session.tokenName)
        this.user = {
          userId: session.userId,
          userName: session.username,
          orgName: session.orgName,
          orgId: session.orgId,
          picturePath: session.picturePath,
          organization: session.organization,
          roles: session.roles,
          permissions: session.permissions
        }
        this.menus = Array.isArray(session.route) ? (session.route as MenuRouteDto[]) : []
      }
      this.restored = true
    },
    setAccessToken(tokenValue: string, tokenName = 'satoken', needModify = false, version = '') {
      const normalizedTokenName = tokenName.trim() || 'satoken'
      this.tokenName = normalizedTokenName
      this.tokenValue = tokenValue
      this.needModify = needModify
      this.version = version
      setHttpAccessToken(tokenValue, normalizedTokenName)
      saveSession({ tokenName: normalizedTokenName, tokenValue, needModify, version })
    },
    setSession(tokenValue: string, user: UserProfile, menus: MenuRouteDto[] = []) {
      this.tokenValue = tokenValue
      setHttpAccessToken(tokenValue, this.tokenName)
      this.user = user
      this.menus = menus
      const session: SessionData = {
        tokenName: this.tokenName,
        tokenValue,
        needModify: this.needModify,
        version: this.version,
        userId: user.userId,
        username: user.userName,
        orgName: user.orgName,
        orgId: user.orgId,
        picturePath: user.picturePath,
        organization: user.organization,
        roles: user.roles,
        permissions: user.permissions,
        route: menus
      }
      saveSession(session)
    },
    clearSession() {
      this.tokenName = 'satoken'
      this.tokenValue = ''
      this.needModify = false
      this.version = ''
      this.user = null
      this.menus = []
      setHttpAccessToken()
      clearSession()
    }
  }
})
